import { useEffect, useRef, useState } from 'react';
import PDFViewer from '../view/PDFViewer';
import { Divider } from 'antd'
import { Outlet, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Test from '../3js/Test';
import Experience from '../3js/experience/Experience';
export default function ExperiencePage() {

    useEffect(() => {
    }, []);

    return (
        <div style={{ height: 'calc(100vh - 67px)' }}>
            <Experience />
        </div>

    );
};